import HeroSection from "../components/HeroSection";
import OurStrength from "./sections/OurStrength";
import IndustrialLighting from "./sections/IndustrialLighting";
import Categories from "./sections/Categories";
import TestimonialSection from "./sections/Testimonial";
import LightingSection from "./sections/LightingSection";
import CaseStudySection from "./sections/CaseStudySection";
import Footer from "../components/Footer";
import VideoComponent from "./sections/VideoComponent";
import "./Home.css"; // Import the CSS file

const Home = () => {
  return (
    <div className="home-container">
      <section className="section hero-section-wrapper">
        <HeroSection />
      </section>

      <section className="section strength-section-wrapper">
        <OurStrength />
      </section>

      <section className="section video-section-wrapper">
        <VideoComponent />
      </section>

      <section className="section industrial-section-wrapper">
        <IndustrialLighting />
      </section>

      <section className="section categories-section-wrapper">
        <Categories />
      </section>

      <section className="section lighting-section-wrapper">
        <LightingSection />
      </section>

      <section className="section testimonial-section-wrapper">
        <TestimonialSection />
      </section>

      {/* <section className="section case-study-section-wrapper">
        <CaseStudySection />
      </section> */}

      <section className="section footer-section-wrapper">
        <Footer />
      </section>
    </div>
  );
};

export default Home;
